exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabContents{padding:30px;background-color:#ffffff;box-shadow:0px 1px 5px rgba(0,0,0,0.1);margin:30px 0px;position:relative;display:block}.createSchemaBtns{float:right;margin-top:-53px}@media (max-width: 991px){.createSchemaBtns{margin-top:-82px}}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/schema/create/create.component.scss
// module id = 1181
// module chunks = 0 2